import { getStatusBadge } from "./StatusUtil";

export function JobHeader({ jobData, jobId }) {
  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  return (
    <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
      <div>
        <h1 className="text-3xl font-bold text-gray-900">{jobData.serviceDetail.service}</h1>
        <p className="text-sm text-gray-500 mt-1">
          Posted on {formatDate(jobData.createdAt)}
        </p>
      </div>
      <div className="flex items-center gap-3">
        {getStatusBadge(jobData.jobStatus)}
      </div>
    </div>
  );
}